// src/data/constants.js

import styles from "../styles/PLMApp.module.css";

export const PLM_CATEGORIES = [
  {
    id: "design",
    name: "Design",
    color: "#c8a96e",
    steps: [
      "Market Research", // 01
      "Trend Research", // 02
      "Product Brief", // 03
      "Range Planning", // 04
      "Concept Development", // 05
      "Sketch Development", // 06
      "Material & Trim Selection", // 07
      "Color Selection", // 08
      "Print Pattern Selection", // 09 — NEW
      "Surface Embellishment", // 10 — NEW (sequins / beads / embroidery / etc.)
      "Initial Costing", // 11
      "Tech Pack Creation", // 12
      "Design Review", // 13
      "Tech Pack Approval", // 14
    ],
  },
  {
    id: "development",
    name: "Development",
    color: "#a8c89e",
    steps: [
      "Prototype Request",
      "First Sample Development",
      "Fit Sample Review",
      "Sample Revision",
      "Counter Sample Development",
      "Material Testing",
      "Construction Review",
      "BOM Finalization",
      "Size Spec Finalization",
      "Grading",
      "Final Sample Approval",
      "Pre-Production Sample Approval",
    ],
  },
  {
    id: "sourcing",
    name: "Sourcing",
    color: "#8eb8d0",
    steps: [
      "Supplier Identification",
      "RFQ / Quotation Collection",
      "Supplier Evaluation",
      "Price Negotiation",
      "MOQ Alignment",
      "Lead Time Confirmation",
      "Material Booking",
      "Lab Dip / Color Approval",
      "Strike Off Approval", // NEW — after lab dip, before trim
      "Trim Approval",
      "Compliance Document Review",
      "Purchase Order Release",
    ],
  },
  {
    id: "manufacturing",
    name: "Manufacturing",
    color: "#d0a888",
    steps: [
      "Production Planning",
      "Capacity Booking",
      "Pre-Production Meeting",
      "Pattern Finalization",
      "Marker Planning",
      "Cutting",
      "Dyeing", // NEW
      "Printing", // NEW
      "Surface Embellishment", // NEW (mirrors Design step — execution phase)
      "Sewing / Assembly",
      "In-Line Quality Check",
      "Finishing",
      "Production Release",
    ],
  },
  {
    id: "quality",
    name: "Quality & Compliance",
    color: "#b8a0d0",
    steps: [
      "Quality Standard Definition",
      "Test Plan Setup",
      "Fabric Testing",
      "Trim Testing",
      "Measurement Check",
      "Fit Approval",
      "In-Line Inspection",
      "Final Random Inspection",
      "Compliance Verification",
      "Labeling Verification",
      "Packaging Verification",
    ],
  },
  {
    id: "packaging",
    name: "Packaging & Inventory",
    color: "#90c8b8",
    steps: [
      "Inner Packaging", // NEW first — polybags / tissue / product-level wrap
      "Outer Packaging", // NEW second — shipper cartons / gift boxes / mailers
      "Packaging Specification Approval",
      "Packing", // MOVED from Manufacturing
      "Barcode / SKU Creation",
      "Carton Planning",
      "Assortment Planning",
      "Warehouse Intake",
      "Goods Receipt",
      "Inventory Allocation",
      "Stock Reconciliation",
      "Dispatch Preparation",
    ],
  },
  {
    id: "impex",
    name: "Documentation & Logistics",
    color: "#9ab0c8",
    steps: [
      "Incoterms & Documentation Checklist",
      "HS Code Classification & Compliance",
      "Commercial Invoice & Packing List",
      "Shipping Instructions & Certificate Requirements",
      "Certificate of Origin & Supporting Certificates",
      "CHA / Customs Broker & Forwarder Coordination",
      "Carrier Selection, Freight Scheduling",
      "Cargo Insurance & Insurance Certificates",
      "Shipping Bill / Export Declaration Filing & Customs Clearance",
      "Export Release, Cargo Handover & Dispatch Confirmation",
      "Bill of Lading / Air Waybill",
      "Final Document Set Compilation, Submission, Tracking & Archiving",
    ],
  },
  {
    id: "distribution",
    name: "Distribution & Retail",
    color: "#c8a0a0",
    steps: [
      "Market Opportunity",
      "Branding and Identity",
      "Channel Strategy",
      "Marketplace Management",
      "Wholesale and Retail",
      "Merchandising",
      "Content Production",
      "Campaign Execution",
      "Brand Collaborations",
      "Marketing Channels",
      "3PL and Fulfillment",
      "Customer Management",
      "Returns Management",
      "Sales and Analytics",
    ],
  },
];

export const STATUSES = [
  { key: "not_started", label: "Not Started", style: styles.statusNotStarted },
  { key: "in_progress", label: "In Progress", style: styles.statusInProgress },
  { key: "waiting", label: "Waiting Approval", style: styles.statusWaiting },
  { key: "done", label: "Done", style: styles.statusDone },
  { key: "not_needed", label: "Not Needed", style: styles.statusNotNeeded },
];

export const DOC_TAGS = [
  "All",
  "Tech Pack",
  "Lab Test",
  "QC Report",
  "Fit Comments",
  "PO",
  "Compliance",
  "Packaging",
  "Shipment",
  "Other",
];

export const COUNTRIES = [
  "India",
  "Afghanistan",
  "Albania",
  "Algeria",
  "Angola",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahrain",
  "Bangladesh",
  "Belarus",
  "Belgium",
  "Benin",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Brazil",
  "Bulgaria",
  "Burkina Faso",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Chile",
  "China",
  "Colombia",
  "Croatia",
  "Czech Republic",
  "Denmark",
  "Ecuador",
  "Egypt",
  "Ethiopia",
  "Finland",
  "France",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Guatemala",
  "Honduras",
  "Hungary",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "South Korea",
  "Kuwait",
  "Laos",
  "Lebanon",
  "Libya",
  "Lithuania",
  "Malaysia",
  "Mali",
  "Mexico",
  "Moldova",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nigeria",
  "North Macedonia",
  "Norway",
  "Oman",
  "Pakistan",
  "Palestine",
  "Panama",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Singapore",
  "Slovakia",
  "South Africa",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Sweden",
  "Switzerland",
  "Syria",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Tunisia",
  "Turkey",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
];

export const LOGO_URL =
  "https://cdn.synaptexglobal.com/Home%20(3240%20x%201080%20px).png";

  export const TEAM_CATEGORIES = [
  "merchandiser",
  "quality-control",
  "designer",
  "logistics",
  "branding-retail",
];

export const FABRIC_CATEGORIES = ["knitted", "woven", "non-woven"];

export const TRADE_ROLES = ["retail", "importer", "wholesale", "technical"];

export const LEAD_STATUSES = ["pending", "flagged", "approved", "rejected"];

export const DB_CATEGORIES = [
  "Spinning",
  "Weaving",
  "Knitting",
  "Dyeing",
  "Printing",
  "Washing",
  "Embroidery",
  "Trims",
  "Other",
];

export const INITIAL_DB_FORM = {
  name: "",
  category: "Spinning",
  country: "",
  city: "",
  contact: "",
  email: "",
  certifications: "",
  notes: "",
  profilePdf: "",
  products: "",
  // category-specific
  specialization: "",
};

export const MILESTONES = [
  "Fabric Inspection",
  "Pre-Production Sample",
  "PP Meeting / Approval",
  "Cut Panel Check",
  "In-Line Inspection",
  "Mid-Production Check",
  "Final Random Inspection",
  "Packing & Labelling Check",
  "Pre-Shipment Inspection",
  "Post-Shipment Review",
];